var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 0C4.48583 0 0 4.48583 0 10C0 15.5142 4.48583 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48583 15.5142 0 10 0ZM9 4.99731C9 4.44651 9.44772 4 10 4C10.5523 4 11 4.44651 11 4.99731V5.49597C11 6.04677 10.5523 6.49328 10 6.49328C9.44772 6.49328 9 6.04677 9 5.49597V4.99731ZM7 8.48788C7 9.03868 7.44772 9.48519 8 9.48519H9V13.4745H8C7.44772 13.4745 7 13.921 7 14.4718C7 15.0226 7.44772 15.4691 8 15.4691H12C12.5523 15.4691 13 15.0226 13 14.4718C13 13.921 12.5523 13.4745 12 13.4745H11V8.48788C11 7.93708 10.5523 7.49057 10 7.49057H8C7.44772 7.49057 7 7.93708 7 8.48788Z","fill":"currentColor"}));
}

IconInfo.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
